/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  Deal,
  PersonalizedDealsResponse,
  PokerSiteDetailResponse,
  PokerSiteNavigation,
  PublicDealsOverviewResponse,
} from '../models'

import dealAugustPromoDealsRetrieveMutator from '../../client'
import dealListListMutator from '../../client'
import dealNavigationPokerSitesListMutator from '../../client'
import dealPersonalizedDealsRetrieveMutator from '../../client'
import dealPokerSitesRetrieveMutator from '../../client'
import dealPublicDealsOverviewRetrieveMutator from '../../client'

/**
 * Provides deals for the August 2025 launch promotion, limited to CoinPoker, Red Star Poker, and America's Cardroom. Applies the same geolocation filtering as personalized deals but is publicly accessible without authentication. Also includes user's location display string and the minimum GTO Wizard subscription price.
 * @summary Get August 2025 Launch Promo Deals
 */
export const dealAugustPromoDealsRetrieve = (signal?: AbortSignal) => {
  return dealAugustPromoDealsRetrieveMutator<PersonalizedDealsResponse>({
    url: `/api/v1/deal/august-promo-deals/`,
    method: 'GET',
    signal,
  })
}

export const getDealAugustPromoDealsRetrieveQueryKey = () => {
  return [`/api/v1/deal/august-promo-deals/`] as const
}

export const getDealAugustPromoDealsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealAugustPromoDealsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>> = ({
    signal,
  }) => dealAugustPromoDealsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealAugustPromoDealsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>
>
export type DealAugustPromoDealsRetrieveQueryError = unknown

export function useDealAugustPromoDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealAugustPromoDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealAugustPromoDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get August 2025 Launch Promo Deals
 */

export function useDealAugustPromoDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealAugustPromoDealsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealAugustPromoDealsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealAugustPromoDealsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>> = ({
    signal,
  }) => dealAugustPromoDealsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealAugustPromoDealsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>
>
export type DealAugustPromoDealsRetrieveSuspenseQueryError = unknown

export function useDealAugustPromoDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealAugustPromoDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealAugustPromoDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get August 2025 Launch Promo Deals
 */

export function useDealAugustPromoDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealAugustPromoDealsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealAugustPromoDealsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Returns a list of all deals that are marked as active and public.
 * @summary List Public Deals
 */
export const dealListList = (signal?: AbortSignal) => {
  return dealListListMutator<Deal[]>({ url: `/api/v1/deal/list/`, method: 'GET', signal })
}

export const getDealListListQueryKey = () => {
  return [`/api/v1/deal/list/`] as const
}

export const getDealListListQueryOptions = <
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealListList>>> = ({ signal }) =>
    dealListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealListListQueryResult = NonNullable<Awaited<ReturnType<typeof dealListList>>>
export type DealListListQueryError = unknown

export function useDealListList<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealListList>>,
        TError,
        Awaited<ReturnType<typeof dealListList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealListList<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealListList>>,
        TError,
        Awaited<ReturnType<typeof dealListList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealListList<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Public Deals
 */

export function useDealListList<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealListListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealListListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealListList>>> = ({ signal }) =>
    dealListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealListListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof dealListList>>>
export type DealListListSuspenseQueryError = unknown

export function useDealListListSuspense<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealListListSuspense<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealListListSuspense<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Public Deals
 */

export function useDealListListSuspense<
  TData = Awaited<ReturnType<typeof dealListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealListListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provides a list of poker sites for navigation, filtered by user's geography (if available) and ordered by priority. Each site is annotated with the count of its relevant active deals.
 * @summary Get Poker Site Navigation List
 */
export const dealNavigationPokerSitesList = (signal?: AbortSignal) => {
  return dealNavigationPokerSitesListMutator<PokerSiteNavigation[]>({
    url: `/api/v1/deal/navigation/poker-sites/`,
    method: 'GET',
    signal,
  })
}

export const getDealNavigationPokerSitesListQueryKey = () => {
  return [`/api/v1/deal/navigation/poker-sites/`] as const
}

export const getDealNavigationPokerSitesListQueryOptions = <
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealNavigationPokerSitesListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>> = ({
    signal,
  }) => dealNavigationPokerSitesList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealNavigationPokerSitesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealNavigationPokerSitesList>>
>
export type DealNavigationPokerSitesListQueryError = unknown

export function useDealNavigationPokerSitesList<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
        TError,
        Awaited<ReturnType<typeof dealNavigationPokerSitesList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealNavigationPokerSitesList<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
        TError,
        Awaited<ReturnType<typeof dealNavigationPokerSitesList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealNavigationPokerSitesList<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Poker Site Navigation List
 */

export function useDealNavigationPokerSitesList<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealNavigationPokerSitesListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealNavigationPokerSitesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealNavigationPokerSitesListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>> = ({
    signal,
  }) => dealNavigationPokerSitesList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealNavigationPokerSitesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealNavigationPokerSitesList>>
>
export type DealNavigationPokerSitesListSuspenseQueryError = unknown

export function useDealNavigationPokerSitesListSuspense<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealNavigationPokerSitesListSuspense<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealNavigationPokerSitesListSuspense<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Poker Site Navigation List
 */

export function useDealNavigationPokerSitesListSuspense<
  TData = Awaited<ReturnType<typeof dealNavigationPokerSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealNavigationPokerSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealNavigationPokerSitesListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provides a list of deals personalized to the authenticated user, based on their geolocation. Also includes user's location display string and the minimum GTO Wizard subscription price.
 * @summary Get Personalized Deals
 */
export const dealPersonalizedDealsRetrieve = (signal?: AbortSignal) => {
  return dealPersonalizedDealsRetrieveMutator<PersonalizedDealsResponse>({
    url: `/api/v1/deal/personalized-deals/`,
    method: 'GET',
    signal,
  })
}

export const getDealPersonalizedDealsRetrieveQueryKey = () => {
  return [`/api/v1/deal/personalized-deals/`] as const
}

export const getDealPersonalizedDealsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPersonalizedDealsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>> = ({
    signal,
  }) => dealPersonalizedDealsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPersonalizedDealsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>
>
export type DealPersonalizedDealsRetrieveQueryError = unknown

export function useDealPersonalizedDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPersonalizedDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPersonalizedDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Personalized Deals
 */

export function useDealPersonalizedDealsRetrieve<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPersonalizedDealsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealPersonalizedDealsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPersonalizedDealsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>> = ({
    signal,
  }) => dealPersonalizedDealsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPersonalizedDealsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>
>
export type DealPersonalizedDealsRetrieveSuspenseQueryError = unknown

export function useDealPersonalizedDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPersonalizedDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPersonalizedDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Personalized Deals
 */

export function useDealPersonalizedDealsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPersonalizedDealsRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPersonalizedDealsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provides detailed information about a specific poker site, identified by its slug. Includes promotions, supported platforms, payment methods, and relevant active deals for the user's geo-location.
 * @summary Get Poker Site Details
 */
export const dealPokerSitesRetrieve = (slug: string, signal?: AbortSignal) => {
  return dealPokerSitesRetrieveMutator<PokerSiteDetailResponse>({
    url: `/api/v1/deal/poker-sites/${slug}/`,
    method: 'GET',
    signal,
  })
}

export const getDealPokerSitesRetrieveQueryKey = (slug: string) => {
  return [`/api/v1/deal/poker-sites/${slug}/`] as const
}

export const getDealPokerSitesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPokerSitesRetrieveQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>> = ({ signal }) =>
    dealPokerSitesRetrieve(slug, signal)

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPokerSitesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPokerSitesRetrieve>>
>
export type DealPokerSitesRetrieveQueryError = unknown

export function useDealPokerSitesRetrieve<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dealPokerSitesRetrieve>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPokerSitesRetrieve<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dealPokerSitesRetrieve>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPokerSitesRetrieve<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Poker Site Details
 */

export function useDealPokerSitesRetrieve<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPokerSitesRetrieveQueryOptions(slug, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealPokerSitesRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPokerSitesRetrieveQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>> = ({ signal }) =>
    dealPokerSitesRetrieve(slug, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPokerSitesRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPokerSitesRetrieve>>
>
export type DealPokerSitesRetrieveSuspenseQueryError = unknown

export function useDealPokerSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPokerSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPokerSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Poker Site Details
 */

export function useDealPokerSitesRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPokerSitesRetrieve>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof dealPokerSitesRetrieve>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPokerSitesRetrieveSuspenseQueryOptions(slug, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provides a public overview of deals from up to 2 of the highest priority active poker sites. For each of these sites, it returns up to 2 of their highest priority deals. Deals are filtered by is_public=True, is_active=True, and the user's geo-location. Priority of deals within a site is determined by public_edge_multiplier (descending). The response is a flat list of deals, where each deal includes details of its poker site.
 * @summary Get Public Deals Overview
 */
export const dealPublicDealsOverviewRetrieve = (signal?: AbortSignal) => {
  return dealPublicDealsOverviewRetrieveMutator<PublicDealsOverviewResponse>({
    url: `/api/v1/deal/public-deals-overview/`,
    method: 'GET',
    signal,
  })
}

export const getDealPublicDealsOverviewRetrieveQueryKey = () => {
  return [`/api/v1/deal/public-deals-overview/`] as const
}

export const getDealPublicDealsOverviewRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPublicDealsOverviewRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>> = ({
    signal,
  }) => dealPublicDealsOverviewRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPublicDealsOverviewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>
>
export type DealPublicDealsOverviewRetrieveQueryError = unknown

export function useDealPublicDealsOverviewRetrieve<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPublicDealsOverviewRetrieve<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
        TError,
        Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPublicDealsOverviewRetrieve<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Deals Overview
 */

export function useDealPublicDealsOverviewRetrieve<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPublicDealsOverviewRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getDealPublicDealsOverviewRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getDealPublicDealsOverviewRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>> = ({
    signal,
  }) => dealPublicDealsOverviewRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DealPublicDealsOverviewRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>
>
export type DealPublicDealsOverviewRetrieveSuspenseQueryError = unknown

export function useDealPublicDealsOverviewRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPublicDealsOverviewRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDealPublicDealsOverviewRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Deals Overview
 */

export function useDealPublicDealsOverviewRetrieveSuspense<
  TData = Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof dealPublicDealsOverviewRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDealPublicDealsOverviewRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
